import { render, staticRenderFns } from "./health_token.vue.js?vue&type=template&id=a2e5e838&vue3!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./health_token.vue?vue&type=template&id=a2e5e838&vue3"
import script from "./health_token.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./health_token.vue?vue&type=script&lang=js&vue3"
export * from "./health_token.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./health_token.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports